import { BUTTON_SIZE, Button, COLOR, Link, Row } from "@ndlib/component-library"
import { EmailIcon, FbIcon, TwitterIcon, shareLocations } from "../shared/ShareLinks"
import { useLocation } from '@reach/router'

type NewsItem = NonNullable<Queries.NewsArticleQuery['strapiNews']>

export const NewsShareLinks: React.FC<{
  newsItem: NewsItem
}> = ({
  newsItem
}) => {
  const location = useLocation()
  const currentUrl = location.href

  return (
    <Row>
      {
        Object.keys(shareLocations).map((key) => {
          const location = shareLocations[key]

          let icon = FbIcon;
          if (key === 'twitter') {
            icon = TwitterIcon;
          } else if (key === 'email') {
            icon = EmailIcon;
          }
          
          return (
            <Link
              to={location.func(newsItem.title, currentUrl)}
              aria-label={'Share on ' + key}
              key={'share_' + key}
              title={'Share on ' + key}
              sx={{mr: 1}}
            >
              <Button
                aria-label={'Share on ' + key}
                primaryIcon={icon}
                size={BUTTON_SIZE.SM}
                customColor={location.color}
                textColor={COLOR.WHITE}
                sx={{fill: 'white', p: 2 }}
              />                  
            </Link>
          )
        })
      }
    </Row>
  )
}
